/*
* 处理人员管理组件
* zxw
* 创建时间：
* 修改时间：2026-07-08
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    message,
    Table,
    Button,
    Input,
    DatePicker,
    Select,
    Space,
    theme,
    Tag,
    Statistic,
} from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    GetButtonActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import WODouserEntity from './WODouserEntity';


const MODULENAME = CNF.navItems[2].submenu[2].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[2].submenu[2].ptn;
const MODULENAME_URL = CNF.navItems[2].submenu[2].url;

const { RangePicker } = DatePicker;


const Lists = (props) => {
    const { btnLists, preGroup, dataLists, currentIndex, pageCount, changeIndex, refresh } = props;

    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            colorSuccess,
            colorSuccessBg,
            fontSize,
            pageSize,

        },
    } = theme.useToken();

    const [open, setOpen] = useState(false);
    const [record, setRecord] = useState(null);

    const update = useCallback((record) => {
        setRecord(record);
        setOpen(true);
    }, [setOpen]);

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.do_user, action, MODULENAME, refresh, uri);
                break;
            default:
                break;
        }
    }, [update, refresh]);

    const hasOpPerm = (
        btnLists.includes(MODULENAME_PTN + '_update') ||
        btnLists.includes(MODULENAME_PTN + '_delete')
    );

    const columns = useMemo(() => [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        { title: '工单编号', dataIndex: 'number', key: 'number', fixed: 'left', width: 150, },
        {
            title: '工单等级', key: 'level', fixed: 'left',
            render: function (record) {
                for (let item of CNF.woLevels) {
                    if (parseInt(record.level) === parseInt(item.value)) {
                        return item.key
                    }
                }
            }
        },
        { title: '工单类型', dataIndex: 'type', key: 'type', },
        {
            title: '绩效权重', key: 'weight',
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '80%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={record.weight} /></Tag>
        },
        {
            title: '绩效分值', key: 'perf_value',
            render: (record) => <Tag color={colorSuccessBg} style={{ width: '80%' }}><Statistic precision={CNF.DPL} styles={{ content: { fontSize: fontSize - 2, color: colorSuccess } }} value={record.perf_value} /></Tag>
        },
        { title: '处理人员', dataIndex: 'do_user', key: 'do_user', },
        { title: '开始时间', dataIndex: 'start_time', key: 'start_time', },
        { title: '结束时间', dataIndex: 'end_time', key: 'end_time', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '操作', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetButtonActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, colorPrimary, colorPrimaryBg, colorSuccess, colorSuccessBg, fontSize, hasOpPerm, operation]);

    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条`,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
            {
                record && <WODouserEntity
                    preGroup={preGroup}
                    btnLists={btnLists}
                    refresh={refresh}
                    open={open}
                    setOpen={setOpen}
                    record={record}
                />
            }
        </>
    );
}

const WODouser = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [number, setNumber] = useState('');
    const [doUser, setDoUser] = useState('');
    const [level, setLevel] = useState(0);
    const [type, setType] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            number,
            do_user: doUser,
            level,
            type,
            start_date: startDate,
            end_date: endDate,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined && value !== 0)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, number, doUser, level, type, startDate, endDate]);

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleNumberChange = useCallback((e) => {
        setNumber(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleDoUserChange = useCallback((e) => {
        setDoUser(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleLevelChange = useCallback((value) => {
        setLevel(value);
        setCurrentIndex(1);
    }, []);

    const handleTypeChange = useCallback((value) => {
        setType(value);
        setCurrentIndex(1);
    }, []);

    const handleTimeIntervalChange = useCallback((_, dateString) => {
        setStartDate(dateString ? dateString[0] : '');
        setEndDate(dateString ? dateString[1] : '');
        setCurrentIndex(1);
    }, []);

    /***
    * 导出为 Excel
    */
    const exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '人员处理明细-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '人员处理明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '工单编号',
                    '工单等级',
                    '工单类型',
                    '绩效权重',
                    '绩效分值',
                    '处理人员',
                    '开始时间',
                    '结束时间',
                    '调整说明'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出数据
    */
    const exportGetData = () => {
        let params = {
            page_size: CNF.maxPageSize,
            current_index: 1,
            number,
            do_user: doUser,
            level,
            type,
            start_date: startDate,
            end_date: endDate,
        };

        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        })
            .done((data) => {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['wo_ulid'];
                            delete item['create_username']
                            delete item['create_displayname']
                            delete item['create_time']
                            delete item['update_time']
                            for (let i of CNF.woLevels) {
                                if (parseInt(item['level']) === parseInt(i.value)) {
                                    item['level'] = i.key
                                }
                            }
                            d.push(item);
                        }
                        exportAsExcel(d);
                    } else {
                        exportAsExcel([]);
                    }
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            })
            .fail((err) => {
                messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
            })
    }

    // 按钮权限判断
    const hasExport = btnLists.includes(MODULENAME_PTN + '_export');

    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input
                    placeholder='工单编号'
                    onChange={handleNumberChange}
                    value={number}
                />
                <Input
                    placeholder='处理人员'
                    onChange={handleDoUserChange}
                    value={doUser}
                />
                <Select
                    allowClear
                    placeholder='工单等级'
                    style={{ width: '100%' }}
                    onChange={handleLevelChange}
                    value={level > 0 ? level : undefined}
                    options={CNF.woLevels.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key
                    }))}
                />
                <Select
                    allowClear
                    placeholder='工单类型'
                    style={{ width: '100%' }}
                    onChange={handleTypeChange}
                    value={type ? type : undefined}
                    options={CNF.woTypes.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.key
                    }))}
                />
                <RangePicker
                    placeholder={['开始日期', '结束日期']}
                    style={{ width: '100%' }}
                    format='YYYY-MM-DD'
                    onChange={handleTimeIntervalChange}
                />
                {hasExport && (
                    <Button
                        title={CNF.actionName.EXPORT + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<ExportOutlined />}
                        onClick={exportGetData}
                    >
                        {CNF.actionName.EXPORT}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                refresh={refresh}
                loading={loading}
            />
        </>
    );
}

export default WODouser;